// Upsell, upgrade nudge, and premium teaser analytics events

export type UpsellSource =
  | 'premium_badge'
  | 'usage_nudge_80'
  | 'usage_nudge_100'
  | 'milestone_strategy'
  | 'milestone_documents'
  | 'milestone_support'
  | 'milestone_onboarding'
  | 'post_checkout_upsell'
  | 'engagement_email_30d'
  | 'sidebar'
  | 'upgrade_page'
  | 'paywall';

export const upsellEvents = {
  premiumTeaserShown: (feature: string, source: string) => ({
    event: 'premium_teaser_shown',
    properties: {
      feature,
      source,
    },
  }),

  premiumTeaserClicked: (feature: string, source: string) => ({
    event: 'premium_teaser_clicked',
    properties: {
      feature,
      source,
    },
  }),

  usageNudgeShown: (feature: string, threshold: 80 | 100, source: string) => ({
    event: 'usage_nudge_shown',
    properties: {
      feature,
      threshold,
      source,
    },
  }),

  usageNudgeDismissed: (feature: string, threshold: 80 | 100, source: string) => ({
    event: 'usage_nudge_dismissed',
    properties: {
      feature,
      threshold,
      source,
    },
  }),

  usageNudgeUpgradeClicked: (feature: string, threshold: 80 | 100, source: string) => ({
    event: 'usage_nudge_upgrade_clicked',
    properties: {
      feature,
      threshold,
      source,
    },
  }),

  milestoneNudgeShown: (milestone: string, source: string) => ({
    event: 'milestone_nudge_shown',
    properties: {
      milestone,
      source,
    },
  }),

  milestoneNudgeClicked: (milestone: string, source: string) => ({
    event: 'milestone_nudge_clicked',
    properties: {
      milestone,
      source,
    },
  }),

  upgradePageViewed: (source: string, tier: string, priceShown: number) => ({
    event: 'upgrade_page_viewed',
    properties: {
      source,
      tier,
      price_shown: priceShown,
      currency: 'USD',
    },
  }),

  upgradePageCtaClicked: (source: string, tier: string) => ({
    event: 'upgrade_page_cta_clicked',
    properties: {
      source,
      tier,
    },
  }),

  postCheckoutUpsellShown: (sourceTier: string) => ({
    event: 'post_checkout_upsell_shown',
    properties: {
      source_tier: sourceTier,
    },
  }),

  postCheckoutUpsellAccepted: (sourceTier: string, timeRemainingSeconds: number) => ({
    event: 'post_checkout_upsell_accepted',
    properties: {
      source_tier: sourceTier,
      time_remaining_seconds: timeRemainingSeconds,
    },
  }),

  postCheckoutUpsellDeclined: (sourceTier: string, timeRemainingSeconds: number) => ({
    event: 'post_checkout_upsell_declined',
    properties: {
      source_tier: sourceTier,
      time_remaining_seconds: timeRemainingSeconds,
    },
  }),
};

export type UpsellEvent = ReturnType<typeof upsellEvents[keyof typeof upsellEvents]>;
